import { BASE_PATH } from '../config/site'

export function registerServiceWorker() {
  if (!import.meta.env.PROD || !('serviceWorker' in navigator)) return
  window.addEventListener('load', () => {
    void navigator.serviceWorker.register(`${BASE_PATH}sw.js`, { scope: BASE_PATH }).catch(() => {
      // Offline support is an enhancement. Tracker storage continues to work in IndexedDB.
    })
  }, { once: true })
}
